import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    showConvocatoria(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/servicio-social/beca/convocatoria/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getServicios(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/servicio-social/beca/convocatoria/${id}/servicios`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getPreinscripcion(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/servicio-social/beca/convocatoria/${id}/pre-inscripcion`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePreinscripcion(ctx, { idConvocatoria, idRequisito }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/servicio-social/beca/convocatoria/${idConvocatoria}/pre-inscripcion/${idRequisito}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    registrarPostulacion(ctx, { idConvocatoria, servicios }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/servicio-social/beca/convocatoria/${idConvocatoria}/postulante`, servicios)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
